import { Component } from '@angular/core';

@Component({
  selector: 'app-termine',
  standalone: true,
  imports: [],
  templateUrl: './termine.html',
  styleUrl: './termine.css'
})
export class Termine {

}
